<div class="form-group mb-3">
    <input 
        #filterBox type="text"
        class="form-control"
        [placeholder]="this.getPlaceHolderTemplate()"
        [title]="this.getPlaceHolderToolTipTemplate()"
        [formControl]="control"
        (keydown.enter)="onEnter()"
        />
</div>

<div *ngIf="this.loading" style="padding-top: 300px;">
    <app-loading/>
</div>

<div *ngIf="!this.loading">
    <span *ngIf="this.items.length == this.getMaxNumberRowsReturned()"><b>Maximum number of items returned ({{ this.getMaxNumberRowsReturned() }}).  Please refine the filter criteria.</b></span>
    <span *ngIf="this.items.length < this.getMaxNumberRowsReturned()"><b> Number of items found: {{ this.items.length }}</b> </span>
</div>

<div class="scroll-container" *ngIf="!this.loading" style="overflow-x: auto;">
    <table class="table table-striped table-hover table-sm">
        <thead>
            <tr>
                <th *ngIf="this.isCondition" style="width: 30px;cursor: pointer;position: sticky;top: 0;"></th>
                <th *ngFor="let column of this.lookup.columns;let i = index" 
                style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap"
                [columnIndex]="i + indexCheckbox"
                storageKey="'itemsTable:'{{column.getSourceName()}}"
                appResizableColumn
                ><a (click)="sortBy(column)" style="cursor: pointer" >{{ column.getHeader() }} {{sortIcon(column.getSourceName())}}</a></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of pageOfItems">
                <td *ngIf="this.isCondition" style="white-space: nowrap;"><input type="checkbox" [checked]="item.checked" (change)="markChecked($event, item)"/></td>
                <td *ngFor="let column of this.lookup.columns" (click)="select(item)" style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                    {{  this.displayValue(item[column.getSourceName()],column.getDataType(), column.getLookup())  }}
                </td>
            </tr>
            <tr *ngIf="items.length==0">
                <td [attr.colspan]="getLookupColumnsLength()" class="text-center py-5">
                    There are no items for current filter
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div *ngIf="!loading && items.length>0" class="card-footer text-center">
    <pagination [items]="items" (changePage)="onChangePage($event)"></pagination>
</div>